import { getConferenceState } from "../../../base/conference";
import {
    getLocalParticipant,
    PARTICIPANT_JOINED,
    PARTICIPANT_LEFT,
    PARTICIPANT_ROLE,
} from "../../../base/participants";
import { MiddlewareRegistry } from "../../../base/redux";
import { activeGuestShareScreen, additionalModerator } from "../../actions";
import { SendCommandOnce } from "./actions";

MiddlewareRegistry.register((store) => (next) => (action) => {
    const result = next(action);
    const { conference } = getConferenceState(store.getState());
    const {
        additional_moderator: additional_moderators = [],
        activate_guest_share_screen: screenSharingPermission = [],
    } = store.getState()["features/nxatel"];
    const { participant: { id } = {} } = action;
    switch (action.type) {
        case PARTICIPANT_JOINED: {
            if (
                conference &&
                getLocalParticipant(store.getState()).role ===
                    PARTICIPANT_ROLE.MODERATOR
            ) {
                SendCommandOnce(
                    "sync-conf-data",
                    JSON.stringify({
                        additional_moderators,
                        screenSharingPermission,
                        id,
                    })
                );
            }
            break;
        }
        case PARTICIPANT_LEFT: {
            if (conference) {
                var index = screenSharingPermission.indexOf(id);
                if (index > -1) {
                    screenSharingPermission.splice(index, 1);
                }
                index = additional_moderators.indexOf(id);
                if (index > -1) {
                    additional_moderators.splice(index, 1);
                }
                store.dispatch(additionalModerator(additional_moderators));
                store.dispatch(activeGuestShareScreen(screenSharingPermission));
            }
            break;
        }
    }
    return result;
});
